

export function getYears(min, max) {
    console.log('min', min)
}

export default {
    getYears: (min, max) => {
        const years = []
        for (let i = min; i <= max; i++) {
            years.push(i)
        }
        return years
    },
}
